import { PlusIcon } from '@heroicons/react/24/outline';

/**
 * AddButton - Botón de acción principal estandarizado
 * 
 * Diseño coral (#e76f51) con bordes redondeados e icono Plus
 * Uso: Botones de creación como "Nuevo Paciente", "Nueva Cita", "Nuevo Insumo"
 * 
 * @param {ReactNode} children - Texto del botón
 * @param {Function} onClick - Handler del click
 * @param {string} className - Clases CSS adicionales (opcional)
 * @param {boolean} disabled - Deshabilitar el botón (opcional)
 */
export default function AddButton({ children, onClick, className = '', disabled = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center gap-2 bg-[#e76f51] hover:bg-[#d65f41] text-white font-semibold text-sm sm:text-base px-4 py-2.5 rounded-lg shadow-sm transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <PlusIcon className="w-5 h-5" strokeWidth={2.5} />
      <span>{children}</span>
    </button>
  );
}
